import React from 'react';
import { Tabs, Button, Modal } from 'antd';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { DAG_RUN_DETAIL_TAB, DAG_RUN_DETAIL_TABS } from '../constants';
import { RunHeader } from './run-header';
import { DetailsTab } from './details-tab';
import { RunCodeTab } from './run-code-tab';
import { TaskInstancesTab } from './task-instances-tab';
import { ClearDagRunDialog } from './clear-dag-run-dialog';
import { useDagRunDetail } from './use-dag-run-detail';
import styles from '../styles.module.scss';

const { TabPane } = Tabs;

const CONFIRM_COPY: Record<string, { title: string; okColor: string; okGlow: string }> = {
    success: { title: 'Mark run as success?', okColor: '#08c46a', okGlow: 'rgba(8, 196, 106, 0.72)' },
    failed: { title: 'Mark run as failed?', okColor: '#ff4d4f', okGlow: 'rgba(255, 77, 79, 0.72)' },
    delete: { title: 'Delete this run? This cannot be undone.', okColor: '#ff4d4f', okGlow: 'rgba(255, 77, 79, 0.72)' },
};

/*
 * DAG-run detail screen — header with clear/mark-success/mark-failed/delete actions, and its tab bar
 */
export function AirflowDagRunDetailScreen() {
    const {
        dagId,
        runId,
        run,
        isLoadingRun,
        refreshKey,
        isClearing,
        confirmAction,
        setConfirmAction,
        activeTab,
        handleTabChange,
        handleRefresh,
        handleClearRun,
        handleCloseClearDialog,
        handleRunCleared,
        handleConfirmAction,
        handleBack,
        handleDagClick,
    } = useDagRunDetail();

    return (
        <div className={`${styles.page} airflowDashboardRoot`}>
            <div className={styles.breadcrumb}>
                <span className={styles.breadcrumbLink} onClick={handleBack}>
                    <FiArrowLeft /> Back to DAG
                </span>
                <Button size="small" onClick={handleRefresh}>
                    <FiRefreshCw />
                </Button>
            </div>
            <RunHeader
                dagId={dagId}
                runId={runId}
                run={run}
                isLoading={isLoadingRun}
                onDagClick={handleDagClick}
                onClearRun={handleClearRun}
                onMarkSuccess={() => setConfirmAction('success')}
                onMarkFailed={() => setConfirmAction('failed')}
                onDeleteRun={() => setConfirmAction('delete')}
            />
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                {DAG_RUN_DETAIL_TABS.map((tab) => (
                    <TabPane tab={tab.label} key={tab.value}>
                        {tab.value === DAG_RUN_DETAIL_TAB.taskInstances && <TaskInstancesTab dagId={dagId} runId={runId} refreshKey={refreshKey} />}
                        {tab.value === DAG_RUN_DETAIL_TAB.code && <RunCodeTab dagId={dagId} refreshKey={refreshKey} />}
                        {tab.value === DAG_RUN_DETAIL_TAB.details && <DetailsTab run={run} isLoading={isLoadingRun} />}
                    </TabPane>
                ))}
            </Tabs>
            {isClearing && <ClearDagRunDialog dagId={dagId} runId={runId} onClose={handleCloseClearDialog} onCleared={handleRunCleared} />}
            {confirmAction && (
                <Modal
                    visible
                    className="airflowDashboardRoot"
                    title={CONFIRM_COPY[confirmAction].title}
                    onCancel={() => setConfirmAction(null)}
                    onOk={handleConfirmAction}
                    okText="Confirm"
                    okButtonProps={{
                        style: {
                            backgroundColor: CONFIRM_COPY[confirmAction].okColor,
                            borderColor: CONFIRM_COPY[confirmAction].okColor,
                            boxShadow: `0 1px 4px 0 ${CONFIRM_COPY[confirmAction].okGlow}`,
                        },
                    }}
                />
            )}
        </div>
    );
}
